// @flow @format
import {handleActions} from 'lib/redux-actions';

import type {Machine} from 'lib/cloner-api';

export type State = {
	entities: {[machineId: ?string]: Machine},
	entitiesFetching: {[userId: string]: boolean},
	byUser: {[userId: ?string]: Machine[]},
};

export type FetchMachinesAction = {
	type: string,
	userId: string,
};

type AddMachinesAction = {
	type: string,
	userId: string,
	payload: Machine[],
};

type RequestMachinesAction = {
	type: string,
	userId: string,
};

// async actions
export const FETCH_MACHINES = 'FETCH_MACHINES';

export const fetchMachines = (userId: string): FetchMachinesAction => ({
	userId,
	type: FETCH_MACHINES,
});

// actions
export const ADD_MACHINES = 'ADD_MACHINES';
export const REQUEST_MACHINES = 'REQUEST_MACHINES';

export const addMachines = (
	userId: string,
	machines: Machine[],
): AddMachinesAction => ({
	userId,
	type: ADD_MACHINES,
	payload: machines,
});

export const requestMachines = (userId: string): RequestMachinesAction => ({
	userId,
	type: REQUEST_MACHINES,
});

export const initialState: State = {
	entities: {},
	entitiesFetching: {},
	byUser: {},
};

const reducer = handleActions(
	{
		[REQUEST_MACHINES]: (
			state: State,
			action: RequestMachinesAction,
		): State => {
			const entitiesFetching = {...state.entitiesFetching};

			entitiesFetching[action.userId] = false;

			return {...state, entitiesFetching};
		},
		[ADD_MACHINES]: (state: State, action: AddMachinesAction): State => {
			const entities = {...state.entities};
			const entitiesFetching = {...state.entitiesFetching};
			const byUser = {...state.byUser};

			byUser[action.userId] = [];
			entitiesFetching[action.userId] = false;

			for (const machine of action.payload) {
				entities[machine.mid] = machine;
				byUser[action.userId].push(machine);
			}

			return {...state, entities, byUser, entitiesFetching};
		},
	},
	initialState,
);

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/entities/machines.js